import { useState } from "react";
import { createPortal } from "react-dom";
import { Copy, Check } from "lucide-react";
import "./LunaDeMiel.css";

export default function LunaDeMiel() {
  const [modalAbierto, setModalAbierto] = useState(false);
  const [copiado, setCopiado] = useState(false);

  const alias = "tinchoyjuli.boda";

  const copiarAlPortapapeles = () => {
    navigator.clipboard.writeText(alias);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  };

  return (
    <section className="luna-de-miel-section" data-aos="fade-up">
      <img src="/regalo.gif" alt="Regalo" className="gif-luna" />
      <h2>¿Regalos?</h2>
      <p>
        Nos basta con tu presencia en este día tan especial.<br />
        Pero si quieres aportar para nuestra luna de miel,<br />
        ¡será recibido con amor!
      </p>
      <button className="btn-ver-cuenta" onClick={() => setModalAbierto(true)}>
        Ver cuenta
      </button>

      {modalAbierto &&
        createPortal(
          <div className="modal-fondo">
            <div className="modal-contenido">
              <button
                className="btn-cerrar-x"
                onClick={() => setModalAbierto(false)}
                aria-label="Cerrar modal"
              >
                &times;
              </button>

              <h3>Alias para transferencia</h3>
              <div className="alias-copiable">
                <span>{alias}</span>
                <button
                  onClick={copiarAlPortapapeles}
                  aria-label="Copiar alias"
                  className="btn-copiar"
                  title="Copiar al portapapeles"
                >
                  {copiado ? (
                    <Check size={18} color="#6a7f39" />
                  ) : (
                    <Copy size={18} color="#333" />
                  )}
                </button>
              </div>
              {copiado && <p className="mensaje-copiado">¡Copiado!</p>}
            </div>
          </div>,
          document.body
        )}
    </section>
  );
}
